import React from "react";
import ReportValue from "@frameworks/web/components/generic/commonTableVal";
import { NuvamaAssets, NuvamaProducts, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import FilterFlags from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/FilterFlags";
const AlltxnsOfAllScripsCards = (props) => {
    const getFilterFlags = (data) => {
        var _a, _b;
        return (React.createElement(FilterFlags, { rowId: data === null || data === void 0 ? void 0 : data.tranId.toString(), parentClass: "justify-content-end pt-1 px-1", filterFlags: {
                corporateAction: false,
                research: false,
                news: false,
            }, tags: [
                {
                    tagName: String(data === null || data === void 0 ? void 0 : data.edelweissTabShortCode).toLocaleUpperCase(),
                    className: "product-filter-tags orange-light-tag",
                    edelweissProdTooltipDesc: (_a = NuvamaAssets.get(data === null || data === void 0 ? void 0 : data.edelweissTabShortCode)) === null || _a === void 0 ? void 0 : _a.display,
                    placement: "bottom",
                    parentClass: "rebrandreports-tooltip-hover",
                    tagId: (data === null || data === void 0 ? void 0 : data.tranId) + "7",
                },
                {
                    tagName: String(data === null || data === void 0 ? void 0 : data.edelweissProductShortCode).toLocaleUpperCase(),
                    className: "product-filter-tags orange-light-tag",
                    edelweissProdTooltipDesc: (_b = NuvamaProducts.get(data === null || data === void 0 ? void 0 : data.edelweissProductShortCode)) === null || _b === void 0 ? void 0 : _b.display,
                    placement: "bottom",
                    parentClass: "rebrandreports-tooltip-hover",
                    tagId: (data === null || data === void 0 ? void 0 : data.tranId) + "8",
                },
                {
                    tagName: String(data === null || data === void 0 ? void 0 : data.txnType).toLocaleUpperCase(),
                    className: "product-filter-tags txn-type",
                    edelweissProdTooltipDesc: data === null || data === void 0 ? void 0 : data.txnType,
                    placement: "bottom",
                    parentClass: "rebrandreports-tooltip-hover",
                    tagId: (data === null || data === void 0 ? void 0 : data.tranId) + "9",
                },
            ] }));
    };
    return (React.createElement(React.Fragment, null, props.transactionList.map((data, idx) => {
        var _a;
        return (React.createElement("div", { className: "details-row-history px-0", key: idx },
            React.createElement("div", { className: "d-flex align-items-baseline justify-content-between" },
                React.createElement("span", { className: "DMSan_14_700 security", onClick: () => {
                        props === null || props === void 0 ? void 0 : props.handleRowClick(data);
                    } }, (_a = data === null || data === void 0 ? void 0 : data.quote) === null || _a === void 0 ? void 0 : _a.displayName),
                React.createElement("div", { className: "d-flex align-items-center justify-content-end gap-1" },
                    data.editable && (React.createElement("span", { className: "ml-8 Roboto_12_400", onClick: (e) => {
                            e.stopPropagation();
                            props === null || props === void 0 ? void 0 : props.gotoEditTransaction(data);
                        } },
                        React.createElement("i", { className: "edel-icon-edit" }))),
                    getFilterFlags(data))),
            React.createElement("div", { className: "mt-3", onClick: () => {
                    props === null || props === void 0 ? void 0 : props.handleRowClick(data);
                } },
                React.createElement("div", { className: "mobile-summ-row" },
                    React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                        React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Date"),
                        React.createElement("span", { className: "RobotoM_14_500 text-nowrap" }, data === null || data === void 0 ? void 0 : data.transactionDate)),
                    React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                        React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Action"),
                        React.createElement("span", { className: `DMSanM_10_500 text-uppercase
                            ${data.action.toUpperCase() === "BUY"
                                ? "txt_green"
                                : "txt_bloodRed"}` }, data.action))),
                React.createElement("div", { className: "mobile-summ-row" },
                    React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                        React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Price"),
                        React.createElement("span", { className: "RobotoM_14_500" },
                            React.createElement(ReportValue, { val: data.transactionPrice, stream: false, onlyval: false }))),
                    React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                        React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Brokerage & Chrgs"),
                        React.createElement("span", { className: "RobotoM_14_500" },
                            React.createElement(ReportValue, { val: data.brokerageCharges, stream: false, onlyval: false })))),
                React.createElement("div", { className: "mobile-summ-row" },
                    React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                        React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Qty"),
                        React.createElement("span", { className: "RobotoM_14_500 num" },
                            React.createElement(ReportValue, { val: data.quantity, stream: false, onlyval: false }))),
                    React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                        React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Net Value"),
                        React.createElement("span", { className: "RobotoM_14_500 num" },
                            React.createElement(ReportValue, { val: data.netValue, stream: false, onlyval: false })))))));
    })));
};
export default AlltxnsOfAllScripsCards;
